import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import useSeriesVariationRates from '../hooks/useSeriesVariationRates';

const VariationRatesTooltip = React.memo(({ seriesID }) => {
    const rates = useSeriesVariationRates(seriesID);

    if (!rates || rates.length === 0) return null;

    return (
        <span className="tooltip-container variation-rates-tooltip">
            <FontAwesomeIcon icon={faCircleInfo} className="variation-rates-tooltip__icon" />
            <span className="tooltip variation-rates-tooltip__content">
                <strong>Variations</strong>
                {[...rates].sort((a, b) => a.cardsPerHit - b.cardsPerHit).map(r => (
                    <span key={r.seriesVariationRateID} className="variation-rates-tooltip__row">
                        {r.CardVariation?.name || 'Unknown'}: 1:{r.cardsPerHit} cards
                    </span>
                ))}
            </span>
        </span>
    );
});

VariationRatesTooltip.propTypes = {
    seriesID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default VariationRatesTooltip;
